module.exports = __webpack_public_path__ + "img/logo.fb4fbf2e.png";